export const POLAR_PRODUCT_IDS = {
  pro: import.meta.env.VITE_POLAR_PRODUCT_PRO ?? "",
  enterprise: import.meta.env.VITE_POLAR_PRODUCT_ENTERPRISE ?? "",
} as const;
